import { AuthorizationService } from './authorization.service';
import { OidcAuthorizationService } from './oidc-authorization.service';
export { Permission, Permissions } from './permissions';
export { TestingAuthorizationService } from './testing-authorization.service';
export { AuthorizationService };

export const provideAuthorizationService = () => ({
  provide: AuthorizationService,
  useExisting: OidcAuthorizationService,
});
